import {GDNDQ_SET_SEQUENCE, GDNDQ_SUBMIT} from '../../Redux.constants';
import {selectNewSequenceInGroup} from './SelectNewSequenceInGroup';
import {submitAnswer} from './SubmitAnswer';

export function GDNDQReducer(state = {}, action) {
  switch (action.type) {
    case GDNDQ_SET_SEQUENCE:
      return selectNewSequenceInGroup(state, action.payload);
    case GDNDQ_SUBMIT:
      return submitAnswer(state, action.payload);
    default:
      return state;
  }
}
